import {Injectable} from '@angular/core';
import {StudentList} from './student-list.model';
import {HttpClient} from '@angular/common/http';
import {System} from '../../shared-components/System';
import {YearService} from '../../shared-components/year/year.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable()
export class StudentListsService {

    // Constructor
    constructor(
        private http: HttpClient,
        private yearService: YearService
    ) {
    }

    // Methods
    public getStudentLists(forAdmin = false, schoolId = this.yearService.defaultYear.SchoolID): Observable<StudentList[]> {
        const queryString = '?yearId=' + this.yearService.defaultYear.Id +
            '&schoolId=' + schoolId +
            '&forAdmin=' + forAdmin;
        return this.http.get<StudentList[]>(System.apiURL.Classroom + 'GetStudentLists' + queryString).pipe(
            map(lists => {
                if (lists) {
                    for (let i = 0; i < lists.length; i++) {
                        lists[i] = System.convert<StudentList>(lists[i], new StudentList());
                    }
                }
                return lists;
            })
        );
    }

    public getStudentList(listId: number): Observable<StudentList> {
        const queryString = '?yearId=' + this.yearService.defaultYear.Id +
            '&schoolId=' + this.yearService.defaultYear.SchoolID +
            '&listId=' + listId;
        return this.http.get<StudentList>(System.apiURL.Classroom + 'GetStudentList' + queryString).pipe(
            map(list => {
                return System.convert<StudentList>(list, new StudentList());
            })
        );
    }

    public saveStudentList(studentList: StudentList): Observable<number> {
        const queryString = '?yearId=' + this.yearService.defaultYear.Id +
            '&schoolId=' + this.yearService.defaultYear.SchoolID;
        return this.http.post<number>(System.apiURL.Classroom + 'SaveStudentList' + queryString, studentList);
    }

    public deleteStudentList(listId: number): Observable<boolean> {
        const queryString = '?yearId=' + this.yearService.defaultYear.Id +
            '&schoolId=' + this.yearService.defaultYear.SchoolID +
            '&listId=' + listId;
        return this.http.get<boolean>(System.apiURL.Classroom + 'DeleteStudentList' + queryString);
    }

    getStudentListSchoolIds(listId: number): Observable<any> {
        return this.http.get(System.apiURL.Classroom + `GetStudentListSchoolIds?listId=${listId}`, { observe: 'response' });
    }
}
